/**
 * P3 SP1 — distinct trails in the loaded session, first-appearance order,
 * glance-lens labels: default trail = "Main", others "Trail N · started <date>".
 * The uuid lives only in `id` (callers may tooltip it). Derived labels are
 * the v1 contract (recent-trails name enrichment is a named follow-up).
 */
import { useMemo } from 'react';

import { useConversation } from '../contexts/ConversationContext';
import { useDefaultTrailId } from './useDefaultTrailId';

export interface SessionTrail { id: string; label: string; }

export function useSessionTrails(): SessionTrail[] {
  const { state } = useConversation();
  const defaultTrailId = useDefaultTrailId();
  return useMemo(() => {
    const seen = new Map<string, string>(); // id → first timestamp
    for (const m of state.messages) {
      const t = (m.metadata as any)?.trail_id;
      if (t && !seen.has(String(t))) seen.set(String(t), (m as any).timestamp ?? '');
    }
    let n = 0;
    return Array.from(seen.entries()).map(([id, ts]) => {
      n += 1;
      if (id === defaultTrailId) return { id, label: 'Main' };
      const d = ts ? new Date(ts).toLocaleDateString() : '';
      return { id, label: d ? `Trail ${n} · started ${d}` : `Trail ${n}` };
    });
  }, [state.messages, defaultTrailId]);
}
